export const KpiZScoreInterpretation = () => {
    return (
        <div className="space-y-3">
            <h3 className="text-base font-headline font-bold text-on-surface">Z-Score Weight Interpretation</h3>
            <div className="bg-surface-container rounded-md p-3 sm:p-4 border border-outline-variant/20">
                <div className="flex items-start gap-2 mb-2">
                    <div
                        className="w-2 h-2 mt-1 rounded-full shrink-0"
                        style={{ backgroundColor: "var(--color-general-purple)" }}
                    ></div>
                    <p className="text-sm font-medium text-on-surface">
                        The weight represents the number of standard deviations required to reach the maximum number of
                        points for a given metric.
                    </p>
                </div>
                <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:mt-6">
                    <div>
                        <h4 className="text-sm font-semibold text-on-surface mb-3">Reaching Maximum Points</h4>
                        <div className="overflow-hidden rounded-md border border-outline-variant/20">
                            <table className="w-full text-xs sm:text-sm">
                                <thead className="bg-surface-container-highest">
                                    <tr>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            Weight
                                        </th>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            Std. dev. to max
                                        </th>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            % reaching max*
                                        </th>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            How rare?
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-surface-container-lowest">
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.0</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.0σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~15.9%</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">
                                            Relatively common
                                        </td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.25</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.25σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~10.5%</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">Above average</td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.5</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.5σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~6.7%</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">
                                            Clearly above average
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-sm font-semibold text-on-surface mb-3">Reaching Zero Points</h4>
                        <div className="overflow-hidden rounded-md border border-outline-variant/20">
                            <table className="w-full text-xs sm:text-sm">
                                <thead className="bg-surface-container-highest">
                                    <tr>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            Weight
                                        </th>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            Std. dev. to 0 pts
                                        </th>
                                        <th className="px-2 py-1.5 text-left text-on-surface font-semibold sm:px-4 sm:py-2">
                                            % at 0*
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-surface-container-lowest">
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.0</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">-1.0σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~15.9%</td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.25</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">-1.25σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~10.5%</td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.5</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">-1.5σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~6.7%</td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">1.75</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">-1.75σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~4.0%</td>
                                    </tr>
                                    <tr className="border-t border-outline-variant/20">
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">2.0</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">-2.0σ</td>
                                        <td className="px-2 py-1.5 text-on-surface sm:px-4 sm:py-2">~2.3%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <p className="text-sm text-on-surface-variant sm:col-span-2">
                        *Assuming an approximately normal distribution.
                    </p>
                </div>
            </div>
        </div>
    );
};
